import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "cookie_consent";

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      setVisible(true);
    }
  }, []);

  function handleAccept() {
    localStorage.setItem(STORAGE_KEY, "accepted");
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 p-4 md:p-0">
      <div className="max-w-4xl mx-auto mb-16 md:mb-4">
        <div className="bg-surface-card border border-white/10 rounded-xl p-4 flex flex-col sm:flex-row items-start sm:items-center gap-4 shadow-lg">
          <p className="text-sm text-gray-300 flex-1">
            We use essential cookies for authentication and session management.
            No tracking cookies are used.{" "}
            <Link to="/privacy" className="text-brand-yellow hover:underline">
              Learn more
            </Link>
          </p>
          <button
            onClick={handleAccept}
            className="shrink-0 px-5 py-2 bg-brand-yellow text-surface font-medium rounded-lg hover:bg-brand-gold transition-colors text-sm"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
